export const messages = [
  {
    from: "Prof. Martin",
    date: "2025-09-09",
    sujet: "Rappel devoirs maths",
    contenu: "N'oubliez pas de faire les exercices 15 à 20 pour jeudi."
  },
  {
    from: "Prof. Durand",
    date: "2025-09-08",
    sujet: "Sortie scolaire",
    contenu: "Merci de rapporter l'autorisation signée avant vendredi."
  },
  {
    from: "CPE",
    date: "2025-09-07",
    sujet: "Absence injustifiée",
    contenu: "Merci de fournir un justificatif pour votre absence du lundi."
  }
];